export default __webpack_public_path__ + "static/media/bank-grey.931be3a0.svg";